





































import Vue from 'vue'
import Utils from '@/helpers/Utils'
import { ConfirmDialogInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'ConfirmDialog',

  data: () => ({
    textToReplace: 'Ova akcija će pokrenuti pretraživač.',
    replaceTextWith: 'Ova akcija će otvoriti novi tab u pretraživaču.'
  }),

  computed: {
    dialog: {
      get (): boolean {
        return this.$props.showPopup
      },
      set () {
        this.$emit('closePopup')
      }
    },
    title (): string {
      const confirmTitle = this.$props.confirmDialog.title.trim()
      if (confirmTitle === this.textToReplace) {
        return this.replaceTextWith
      }
      return confirmTitle
    }
  },

  methods: {
    handleClick (): void {
      const uri = this.uri as Record<string, unknown> | string
      // Handle logout url
      if (this.$props.view === 'logout') {
        this.$router.push({ name: 'Logout' })
        this.$emit('closePopup')
        return
      }
      // Fix for unset pin action as it doesn't have view defined
      if (typeof uri === 'string' && uri.includes('pin/unset')) {
        this.getView('left', uri, this.getInputRefs() || null)
        return
      }

      this.getView(this.view, uri, this.getInputRefs())
      this.$emit('closePopup')
    },
    getInputRefs: function (): URLSearchParams | null {
      if (this.$props.postParams === null) {
        return null
      }
      const refs = this.$props.postParams as Array<string>
      return Utils.getPostParamsByRefs(refs)
    }
  },

  props: {
    showPopup: {
      type: Boolean,
      required: true,
      default: false
    },
    confirmDialog: {
      type: Object as () => ConfirmDialogInterface,
      required: true
    },
    view: {
      type: String,
      required: true
    },
    uri: {
      required: true
    },
    postParams: {
      default: null
    }
  }
})
